import { render, staticRenderFns } from "./CompCreateUser.vue?vue&type=template&id=624f1712&scoped=true"
import script from "./CompCreateUser.vue?vue&type=script&lang=js"
export * from "./CompCreateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624f1712",
  null
  
)

export default component.exports